export default __webpack_public_path__ + "static/media/GT.ba4bcd88.svg";